
import LocationTrailerResultCard from '@/components/LocationTrailerResultCard.vue';
import FbxButton from '@/components/fbx-button.vue';
import NearbyTrailerResult from '@/types/NearbyTrailerResult';
import { PropType, defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
    components: {
        FbxButton,
        LocationTrailerResultCard,
    },
    props: {
        results: {
            type: Array as PropType<NearbyTrailerResult[]>,
            required: true,
        },
    },
    emits: ['navigateBack'],
    computed: {
        ...mapGetters({
            trailerAssociationsEnabled: 'trailerAssociationsEnabled',
        }),
    },
    methods: {
        navigateToEnterTrailer(): void {
            this.$router.push({ name: 'EnterTrailer' });
        },
    },
});
